import { db } from '../helpers/db';
import store from '../helpers/store';

export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export const blobToBase64 = (blob: Blob | File): Promise<string> => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
};

export const base64Size = (base64Data: string): number => {
  const kb = Math.ceil((base64Data.length * 6) / 8 / 1000);
  return kb / 1000;
};

export const delay = ms => new Promise(res => setTimeout(res, ms));

export const getLogMessage = async (param_req_id: string = '', param_redirect_id: string = '', param_token: string = '') => {
  const ectData = await db.getAllEctData();
  return {
    store_values: { request_id: store.requestId, redirect_id: store.redirectId, token: store.token },
    session_values: ectData,
    parameter_values: { request_id: param_req_id, redirect_id: param_redirect_id, token: param_token },
  };
};

export function getUUID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  } else {
    // Fallback to UUID v4 generator
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
